import { BaseService } from './baseService';
import { PatientRecordDto, PatientRecordFormData } from '../types/patientRecord';

class PatientRecordService extends BaseService<PatientRecordDto, PatientRecordFormData> {
    constructor() {
        super('/PatientRecord');
    }
}

export const patientRecordService = new PatientRecordService();